import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CircleLock } from '../../../assets/GrayClock.svg';
import CustomDropdown from "../../CustomDropdown/CustomDropdown";
import styles from "../CreateParameterPopup.module.css";
import LabelParameters from "../LabelParameters";
const Date = ({
  parameterData,
  handleChange,
  editingInput,
  setEditingInput,
}) => {
  const [t] = useTranslation("Contacts");
  return (
    <div>
      <LabelParameters
        value={parameterData.date}
        text={"date"}
        editingInput={editingInput}
        setEditingInput={setEditingInput}
      >
        <div className={styles.dateContainer}>
            <CircleLock/>
          <CustomDropdown
            editable={true}
            editing={true}
            options={[
              t("length"),
              t("weight"),
              t("volumen"),
              t("time"),
              t("speed"),
            ]}
            selectedOption={parameterData?.date}
            setSelectedOption={(option) =>
              handleChange({ name: "date", newValue: option })
            }
            father={"automate"}
          />
        </div>
      </LabelParameters>
    </div>
  );
};

export default Date;
